module.exports = __webpack_public_path__ + "static/media/backgroundwedoio.9b6d3145.svg";